import { FormattedMessage } from "react-intl";
import { reports } from "./reports";

export const adoptionReport = {
  label: <FormattedMessage id="Adoption_Report" />,
  path: (tenantName) => `/${tenantName}/reports/adoptionReport`,
  navLinks: (navigate, tenantName) => [
    {
      key: 1,
      label: "Reports",
      path: `${reports.path(tenantName)}`,
      onClick: () => navigate(`${reports.path(tenantName)}`),
    },
    {
      key: 2,
      label: <FormattedMessage id="Adoption_Report" />,
      path: `${reports.path(tenantName)}`,
      onClick: () => navigate(`${reports.path(tenantName)}`),
    },
  ],
  tiles: (navigate, val1, val2, val3, val4, val5, val6, val7, val8) => [
    {
      key: 1,
      label: <FormattedMessage id="Report_TotalUser" />,
      value: val1,
    },
    {
      key: 2,
      label: "Least App Accessed",
      value: val2,
    },
    {
      key: 3,
      label: "App Installation",
      value: val3,
    },
    {
      key: 4,
      label: "Least Attempt on Shotclass",
      value: val4,
    },
    {
      key: 5,
      label: "App Access Percentage",
      value: val5 + "%",
    },
    {
      key: 6,
      label: "Mobile App Adoption",
      value: val6 + "%",
    },
    {
      key: 7,
      label: <FormattedMessage id="Report_ClassAttemptPercentage" />,
      value: val7 + "%",
    },
  ],
  graphs: (data1, data2, data3, data4, data5) => [
    {
      key: 1,
      type: "verticalBar",
      heading: <FormattedMessage id="Report_MobileAppInstallationTrend" />,
      xAxesText: "",
      yAxesText: "",
      data: data1,
    },
    {
      key: 2,
      type: "verticalBar",
      heading: <FormattedMessage id="REPORT_COMPLETIONTREND_TXT" />,
      xAxesText: "",
      yAxesText: "",
      data: data2,
    },
    {
      key: 3,
      type: "verticalBar",
      heading: "Select Class Wise Usage",
      xAxesText: "",
      yAxesText: "",
      data: data3,
    },
    {
      key: 4,
      type: "verticalBar",
      heading: "Select User Group and Total Classes",
      xAxesText: "",
      yAxesText: "",
      data: data4,
    },
    {
      key: 5,
      type: "verticalBar",
      heading: <FormattedMessage id="Report_UserGroupandApplicationAccess" />,
      xAxesText: "",
      yAxesText: "",
      data: data5,
    },
  ],
  inputField: (formArgs) => [
    {
      key: 1,
      label: "From Date",
      type: "date",
      isFromDate: true,
      isRquired: true,
      onChange: (e) => formArgs.onFromDateChange(e),
    },
    {
      key: 2,
      label: "To Date",
      type: "date",
      isRequired: true,
      isLimit: true,
      maxSelected: 90,
      validationLabel: "Days",
      min: formArgs.fromDate,
      onChange: (e) => formArgs.onToDateChange(e),
    },
    {
      key: 3,
      isMulti: true,
      type: "multiSelect",
      isRequired: true,
      name: "userGroup",
      label: "Users Group",
      isLimit: true,
      defaultValue: formArgs.selectedUserGroup,
      placeholder: "Select User Groups",
      options: formArgs.userGroupOptions,
      onChange: (e) => formArgs.onUserGroupSelected(e),
      maxSelected: 15,
      validationLabel: "Groups",
      selectedValue: formArgs.selectedUserGroup,
    },
    {
      key: 4,
      isMulti: true,
      type: "multiSelect",
      isRequired: true,
      name: "className",
      label: <FormattedMessage id="SELECT_CLASSES" />,
      isLimit: true,
      defaultValue: formArgs.selectedClassName,
      placeholder: "Select Shotclasses",
      options: formArgs.classNameOptions,
      onChange: (e) => formArgs.onClassNameSelected(e),
      maxSelected: 15,
      validationLabel: "Classes ",
      selectedValue: formArgs.selectedClassName,
    },
    {
      key: 5,
      type: "searchBtn",
      isCombine: true,
      onClick: (e) => formArgs.handleReset(e),
    },
    {
      key: 6,
      type: "searchBtn",
      isCombine: false,
      onClick: (e) => formArgs.onFilterSearch(e),
    },
  ],
};
